<template>
  <v-dialog
    v-model="opened"
    content-class="text-field-edit"
    max-width="350"
    persistent
  >
    <h3 class="text-field-edit__title mb-4">
      {{ label || $t('common.btns.edit') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="text-field-edit" @submit.prevent="onSubmit">
      <v-textarea
        v-model="text"
        height="100"
        dense
        outlined
        no-resize
        :rules="rules"
      />
      <v-btn elevation="0" type="submit" color="warning" block>
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    paramName: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    currentValue: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    text: '',
  }),
  watch: {
    opened(val) {
      if (val && this.currentValue) {
        this.text = this.currentValue;
      }

      if (!val) {
        this.$refs['text-field-edit'].reset();
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    rules() {
      const rules = [];

      if (this.type === 'number') {
        rules.push(this.onlyNumbers);
      }

      if (this.required) {
        rules.push(this.isRequired);
      }

      return rules;
    },
  },
  methods: {
    onSubmit() {
      const isValid = this.$refs['text-field-edit'].validate();

      if (!isValid) return;

      this.$emit('save', { [this.paramName]: this.text });
      this.opened = false;
    },
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
  },
};
</script>

<style lang="scss">
.text-field-edit {
  padding: 10px;
  background-color: #fff;

  &__title {
    font-size: 18px;
    color: #464646;
    padding-right: 20px;
    line-height: 1.3;
  }
}
</style>
